import pino from 'pino';

const pinoConfig =
  process.env.NODE_ENV === 'production'
    ? {
      timestamp: () => `,"time":"${new Date().toISOString()}"`,
      messageKey: 'message',
      useLevelLabels: true,
    }
    : {
      prettyPrint: { colorize: true },
      base: {},
      timestamp: () => `,"time":"${new Date().toISOString()}"`,
      useLevelLabels: true,
    };

const Logger = () => pino(pinoConfig);

export default Logger();
